/* eslint-disable import/prefer-default-export */
export const isEmpty = (value) => (value === null || value === undefined || value?.length === 0);
